module.exports = __webpack_public_path__ + "static/media/pagination-left-arrow.96b9688e.svg";